/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kayenzi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bugarama": ["Buhurura", "Munyegera", "Nyarurama", "Remera"],
  "Cubi": ["Gitwa", "Kamabuye", "Ntwari", "Nyakigezi", "Rwishywa"],
  "Kayonza": ["Kigwene", "Muza", "Nyabubare"],
  "Kirwa": ["Gasamba", "Gisizi", "Gitwa", "Kigunga", "Ruheka"],
  "Mataba": ["Gasasa", "Gikurubuye", "Kabana", "Nyarubaya", "Rugoma"],
  "Nyamirama": ["Bushara", "Kibuye", "Rugaragara"]
};